import styled from 'styled-components';

export const Container = styled.div`
    width:100% ;
    padding-top:50px;
    display:flex;
    justify-content: center ;
    align-items:center ;
    flex-direction:column;
    background-color:#fff ;
    row-gap:20px;
    
`
export const IconLoading =styled.div`
    img{
        width:150px ;
    }
`